import { MediaMatcher } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { MaterialModule } from '../../shared/material/material.module';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthCustomService } from '../../security/auth-custom.service';
import { ShoppingCardComponent } from '../../my-account/shopping-card/shopping-card.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogTermsComponent } from '../../shared/dialogs/dialog-terms/dialog-terms.component';
import { DialogPrivacyPolicyComponent } from '../../shared/dialogs/dialog-privacy-policy/dialog-privacy-policy.component';

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [MaterialModule, CommonModule, ShoppingCardComponent],
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent  {

  authCustom = inject(AuthCustomService);
  private authService = inject(AuthService);
  router = inject(Router);
  deviceService = inject(DeviceDetectorService);
  media = inject(MediaMatcher);
  changeDetectorRef = inject(ChangeDetectorRef);
  dialog = inject(MatDialog);
  
  isMobile!: boolean;
  mobileQuery!: MediaQueryList;
  private _mobileQueryListener: (() => void) | undefined;
  isAuthenticated = this.authCustom.hasValidToken();

  ngOnInit(): void {

    this.isMobile = this.deviceService.isMobile();
    this.mobileQuery = this.media.matchMedia('(max-width: 768px)');
    this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    if (this._mobileQueryListener) {
      this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
    }
  }

  openTermsDialog(): void {
    this.dialog.open(DialogTermsComponent, {
      width: '90vw',
      maxWidth: '800px',
      height: '80%',
      maxHeight: '800px',
      panelClass: 'dialog-responsive'
    });
  }

  openPrivacyPolicyDialog(): void {
    this.dialog.open(DialogPrivacyPolicyComponent, {
      width: '90vw',
      maxWidth: '800px',
      height: '80%',
      maxHeight: '800px',
      panelClass: 'dialog-responsive'
    });
  }

  isAuth() {
    if (this.authCustom.hasValidToken()) {
      this.router.navigate(['/my-account']);
    }
    // return this.authCustom.hasValidToken();
  }
}
